<template>
  <div>
    <component :is="component" :preview="preview"/>
  </div>
</template>

<script>
import ReportReparation from "@/components/report/preview/ReportReparation";
import ReportInspection from "@/components/report/preview/ReportInspection";
import STATES from '@/models/States'
import Util from "@/util/index";

export default {
  props: {
    isReparation: { type: Boolean, default: false },
    body: { type: Object, default: () => {} },
    report: { type: Object, default: () => {} },
  },
  components: {
    ReportReparation,
    ReportInspection,
  },
  data: () => ({
    preview: null,
    inspeccion: STATES.WORK_ORDER_TYPE_INSPECCION,
    reparacion: STATES.WORK_ORDER_TYPE_REPARACION,
  }),
  computed: {
    loading: {
      get () {
        return this.$store.state.loading
      },
      set (val) {
        this.$store.commit('loading', val)
      }
    },
    component() {
      return this.isReparation ? 'report-reparation' : 'report-inspection'
    }
  },
  methods: {
    getPreview () {
      this.loading = true

      this.$store.dispatch('reports/preview', this.body)
        .then(response => {
          this.preview = response.data.data
        })
        .catch(error => {
          var errorToastMessage = "Ha ocurrido un error cargando la previsualización."
          Util.showErrorToast(this, error, errorToastMessage);
        })
        .finally(() => {
          this.loading = false
        })
    },
  },
  created() {
    this.getPreview()
  }
}
</script>

<style >
.border-black-left-start {
  border: 1px solid black !important;
}
.border-black-left {
  border-left: 1px solid black !important;
  border-right: 1px solid black !important;
  border-bottom: 1px solid black !important;
}
.border-black-right-start {
  border-top: 1px solid black !important;
  border-right: 1px solid black !important;
  border-bottom: 1px solid black !important;
}
.border-black-right {
  border-right: 1px solid black !important;
  border-bottom: 1px solid black !important;
}
.fill-primary {
  background-color: #91a83d !important;
}
</style>
